import { SagaIterator } from 'redux-saga';
import { takeEvery } from 'redux-saga/effects';
import { fetchBlFiles } from '../reducer';
import { workerFetchGetBlFileList } from './workers';

export default function* watchBlFiles(): SagaIterator {
  yield takeEvery(fetchBlFiles, workerFetchGetBlFileList);
}
